<template>
  <div class="content if-profile competitive report-tab">
    <div class="md-layout industry-sumnary">
      <MRReportHeader :headerData="this.headerData" />

      <div class="md-layout-item p-0">
        <md-card class="if_card">
          <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
              <md-card-header class="md-card-header-icon">
                Competitive Summary
                <br />
              </md-card-header>
            </div>
          </div>
          <md-card-content>
            <div class="md-layout p-4">
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <table-card class="md-card-profile">
                  <template slot="header" header-color="rose">
                    <h4 class="title">
                      <div
                        class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                      >Competitive Analysis Summary</div>
                    </h4>
                  </template>
                  <template slot="content">
                    <div class="md-layout">
                      <div class="md-layout-item md-size-100 p-0">
                        <md-table v-model="tableDataAnalysisSummary">
                          <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell
                              md-label="Competitive Analysis Summary"
                            >{{ item.profileYear }}</md-table-cell>
                            <md-table-cell md-label>
                              {{
                                item.firms
                              }}
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </div>
                    </div>
                  </template>
                </table-card>
              </div>
              <div class="md-layout-item md-medium-size-100 md-size-50">
                <table-card class="md-card-profile">
                  <template slot="header" header-color="rose">
                    <h4 class="title">
                      <div
                        class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                      >Variance from Market Area Industry:</div>
                    </h4>
                  </template>

                  <template slot="content">
                    <div class="md-layout">
                      <div class="md-layout-item md-size-100 p-0">
                        <md-table v-model="tableDataVarianceMarketAreaIndustry">
                          <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell md-label>
                              {{
                                item.profileYear
                              }}
                            </md-table-cell>
                            <md-table-cell md-label>
                              {{
                                item.firms
                              }}
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </div>
                    </div>
                  </template>
                </table-card>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { TableCard } from '@/components';
import { mapState } from 'vuex';
import MRReportHeader from './_partials/MRReportHeader.vue';

export default {
  components: {
    TableCard,
    MRReportHeader,
  },
  props: ['headerData'],
  data() {
    return {
      showDialog: false,
      tableDataAnalysisSummary: [],
      tableDataVarianceMarketAreaIndustry: [],
      tableDataSalesRank: [],
    };
  },
  computed: {
    ...mapState({
      cmn: (state) => state.user.market_report['data']['cmn'],
      annualSalesRank: (state) =>
        state.user.market_report.data.data['annualSalesRank'],
    }),
    average() {
      if (this.cmn.user_sales_variance > 0) {
        return 'greater than average';
      } else if (this.cmn.user_sales_variance < 0) {
        return 'greater than average';
      } else {
        return '';
      }
    },
  },
  mounted() {
    if (!this.annualSalesRank) {
      return;
    }

     this.tableDataSalesRank = Object.entries(this.annualSalesRank).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );

    this.tableDataAnalysisSummary.push(
      {
        profileYear: 'Sales Rank:',
        firms: this.tableDataSalesRank[0].dates[1],
      },
      {
        profileYear: 'Sales Percentile:',
        firms: this.tableDataSalesRank[1].dates[1],
      },
      {
        profileYear:
          'Sales Change (' +
          this.cmn.release_year1 +
          ' to ' +
          this.cmn.release_year3 +
          '):',
        firms: this.tableDataSalesRank[2].dates[1],
      }
    );
    this.tableDataVarianceMarketAreaIndustry.push(
      {
        profileYear: 'Average Site Sales:',
        firms: this.cmn.variance_avg_site,
      },
      {
        profileYear: 'Median Site Sales:',
        firms: this.cmn.variance_median_site,
      },
      {
        profileYear: 'Average Small Business Sales:',
        firms: this.cmn.variance_sb,
      },
      {
        profileYear: 'Average Industry Wage:',
        firms: this.cmn.variance_wage,
      },
      {
        profileYear: 'Sales per Employee:',
        firms: this.cmn.variance_spe,
      },
      {
        profileYear: 'Efficiency Index (SPE/Avg. Wage):',
        firms: this.cmn.efficiency_index,
      },
      {
        profileYear: 'Rent per Employee:',
        firms: this.cmn.variance_rent,
      }
    );
  },
  methods: {},
};
</script>
<style lang="scss">
.marketprof-competitors {
  .dialog-box {
    display: flex;
    justify-content: flex-end;
    margin: 10px 30px;
  }
}

.icon-arrow {
  transform: rotate(180deg) !important;
}
</style>
